import { offersConstants } from '../constants/offers';
import { streamConstants } from '../constants/streams';
import { webmasterConstants } from '../constants/webmaster';

const initialState = {
  catalog: [],
  filters: {},
  tabs: [],
  catalogFilters: {},
  selected: {
    modifies: {},
    admit: {},
  },
  extra: {
    basePath: '',
    collections: {},
    groups: [],
  },
  supportHours: [],
  recommendedOffers: [],
  landingsInfo: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case offersConstants.SET_OFFER_TO_MY:
      return {
        ...state,
        catalog: state.catalog.map(offer => {
          if (offer.id === action.id) {
            return {
              ...offer,
              modifies: {
                ...offer.modifies,
                is_my: true,
              },
            };
          }

          return offer;
        }),
      };

    case offersConstants.RESET_OFFER:
      return {
        ...state,
        selected: {
          ...initialState.selected,
        },
      };

    case offersConstants.SET_OFFER_SUCCESS:
      return {
        ...state,
        selected: {
          ...initialState.selected,
          ...action.offer,
        } 
      };

    case offersConstants.SET_OFFERS_TABS_SUCCESS:
      const tabs = action.tabs.map((tab, index) => {
        if(state.tabs[index] && state.tabs[index].count && state.tabs[index].count >= 0) {
          return {
            ...state.tabs[index],
            ...tab,
          };
        } else {
          return tab;
        }
      });
      return {
        ...state,
        tabs,
      };

    // case offersConstants.SET_OFFER_TO_MY_SUCCESS_TAB_INCREMENT:
    //   const tabs = state.tabs.map(tab => {
    //     if(tab.prefix === 'my') {
    //       return {...tab, count: tab.count++};
    //     } else {
    //       return tab;
    //     }
    //   });
    //   return {
    //     ...state,
    //     tabs,
    //   };
    case offersConstants.SET_OFFERS_LIST_REQUEST:
      return {
        ...state,
        // catalog: [],
      };

    case offersConstants.SET_OFFERS_LIST_SUCCESS:
      const newTabs = state.tabs.map(tab => {
        const count = action.ammounts[tab.prefix];
        return {
          ...tab,
          count,
        };
      });
      return {
        ...state,
        catalog: action.offers,
        tabs: newTabs,
      };

    case offersConstants.SET_OFFER_FILTERS_SUCCESS:
      return {
        ...state,
        filters: action.filters,
      };

    case offersConstants.RESET_OFFERS_CATALOG_FILTER:
      const { name } = action;
      const catalogFilters = name ? { ...state.catalogFilters, [name]: [] } : {};

      return {
        ...state,
        catalogFilters,
      };

    case offersConstants.SET_OFFERS_CATALOG_FILTER:
      return {
        ...state,
        catalogFilters: {
          ...state.catalogFilters,
          ...action.filter,
        },
      };

    case offersConstants.SET_OFFER_NEWS_REQUEST:
      return {
        ...state,
        news: [],
      };

    case offersConstants.SET_OFFER_NEWS_SUCCESS:
      return {
        ...state,
        news: action.news,
      };

    case offersConstants.SET_OFFER_FILES_REQUEST:
      return {
        ...state,
        selected: {
          ...state.selected,
          files: [],
        },
      };

    case offersConstants.SET_OFFER_FILES_SUCCESS:
      return {
        ...state,
        selected: {
          ...state.selected,
          files: action.files,
        },
      };

    case offersConstants.SET_OFFER_PROMO_REQUEST:
      return {
        ...state,
        promotions: [],
      };

    case offersConstants.SET_OFFER_PROMO_SUCCESS:
      return {
        ...state,
        promotions: action.promotions,
      };
    case offersConstants.RESET_OFFER_PROMO:
      return {
        ...state,
        promotions: [],
      };

    case offersConstants.SET_OFFER_EXTRA_GROUPS_REQUEST:
      return {
        ...state,
        extra: {
          ...state.extra,
          groups: [],
        },
      };

    case offersConstants.SET_OFFER_EXTRA_GROUPS_SUCCESS:
      return {
        ...state,
        extra: {
          ...state.extra,
          groups: action.groups,
        },
      };

    case offersConstants.SET_OFFER_EXTRA_COLLECTION_SUCCESS:
      const { collection, groupId } = action;

      return {
        ...state,
        extra: {
          ...state.extra,
          basePath: action.basePath,
          collections: {
            ...state.extra.collections,
            [groupId]: collection,
          },
        },
      };

    // case streamConstants.RESET_STREAM:
    //   return {
    //     ...state,
    //     selected: {
    //       ...initialState.selected,
    //     },
    //   };

    case webmasterConstants.OFFER_REQUEST_SUCCESS:
      const catalog = state.catalog.map(offer => {
        if (offer.id === action.offerId) {
          return {
            ...offer,
            modifies: {
              ...offer.modifies,
              is_my: true,
            },
          };
        } else {
          return offer;
        }
      });

    case offersConstants.SET_RECOMMENDED_OFFERS_SUCCESS:
      return {
        ...state,
        recommendedOffers: action.recommendedOffers,
      };
    case offersConstants.SET_LANDINGS_INFO:
      return {
        ...state,
        landingsInfo: {...state.landingsInfo, [action.info.id]: action.info},
      };
    
    case offersConstants.SET_OFFER_SUPPORT_HOURS_SUCCESS:
      return {
        ...state,
        supportHours: action.supportHours,
      };
    case offersConstants.SET_OFFER_SUPPORT_HOURS_FAILURE:
      return {
        ...state,
        supportHours: [],
      };

    default:
      return state;
  }
};
